import type { ShotScenario } from '../../lib/trajectory/types';

interface ScenarioSelectorProps {
  value: ShotScenario;
  onChange: (next: ShotScenario) => void;
}

const SCENARIOS: ReadonlyArray<{ value: ShotScenario; label: string }> = [
  { value: 'broadside-near',  label: 'Broadside (near)' },
  { value: 'broadside-far',   label: 'Broadside (far)' },
  { value: 'quartering-away', label: 'Quartering away' },
  { value: 'quartering-into', label: 'Quartering into' },
  { value: 'frontal',          label: 'Frontal' },
  { value: 'steep-down',       label: 'Steep downhill' },
  { value: 'steep-up',         label: 'Steep uphill' },
];

export function ScenarioSelector({ value, onChange }: ScenarioSelectorProps) {
  return (
    <div className="scenario-selector">
      <h3>Shot scenario</h3>
      <select value={value} onChange={(e) => onChange(e.target.value as ShotScenario)}>
        {SCENARIOS.map((s) => (
          <option key={s.value} value={s.value}>
            {s.label}
          </option>
        ))}
      </select>
      <p className="scenario-note">
        Scenario affects the deflection-probability factor in the Forge Score.
        Quartering-into is the highest-risk for mechanical heads.
      </p>
    </div>
  );
}
